import optionAPI from '@/apis/other/optionAPI';
import { OptionKey } from '@/commons/enumTourGuide.js';
import { OptionValueType } from '@/commons/enumUserOption.js';

export default {
  namespaced: true,
  state: () => ({
    isActive: false,
    steps: [],
    step: 1,
    isGettedData: false,

    /**
     * Ví dụ:
     * tourGuideConfig: {
     *   dashboard: 2 --> Là bước hiện tại ở màn tổng quan, Nếu ko có thì là chưa đi bước nào
     * }
     */
    tourGuideConfig: {},
    tourGuideUpdate: false,
    tourGuideUpdateStep: -1,
    isShowTourGuideDashBoard: true, // Có hiển thị tour guide ở dash board không(nếu đi qua khám phá thì k hiển thị)
    tourLiveChat: false,
  }),
  mutations: {
    /**
     * Mở tour guide
     * @param {*} state
     * @author: BMThang(29/03/2023)
     */
    openTourGuide: (state, { steps, step }) => {
      /*
      Ví dụ về 1 bước
      const steps = {
        key: 'Dashboard' Key để xác định tour guide nào import { TourGuideKey } from '@/commons/enumTourGuide.js';,
        width: 0, // rộng
        height: 0, // cao
        left: 0, // trái
        top: 0, // phải
        position: {}, // position của popover
        nextStepFunc: () => {}, // hàm thực hiện khi nhấn tiếp tục
        prevStepFunc: () => {}, // hàm thực hiện khi nhấn quay lại
        title: '', // tiêu đề popover
        msg: '' // thông điệp của popover
      }
      */
      // Chạy xong khám phá mới mở hdsd
      if(state.tourGuideUpdate) {
        state.isActive = true;
        state.step = step;
        state.steps = steps;
      }
    },

    /**
     * Đóng tour guide
     * @param {*} state
     * @author: BMThang(29/03/2023)
     */
    closeTourGuide: (state) => {
      state.tourLiveChat =
        state.steps.findIndex((item) => {
          return item.key === 'Dashboard';
        }) > -1
          ? true
          : false;

      state.isActive = false;
      state.steps = [];
      state.step = 1;
    },

    /**
     * Chuyển bước
     * @param {*} state
     * @param {number} step Bước mới
     * @author: BMThang(29/03/2023)
     */
    setStep: (state, step) => {
      state.step = step;
    },

    /**
     * Xét thiết lập tour guide
     * @param {*} state
     * @param {object} tourGuideConfig Thiết lập tour guide
     * @author: BMThang(29/03/2023)
     */
    setTourGuideConfig: (state, tourGuideConfig) => {
      state.tourGuideConfig = tourGuideConfig;
    },

    /**
     * Xét đã lấy đc dữ liệu chưa
     * @param {*} state
     * @param {object} isGettedData Trạng thái đã lấy đc dữ liệu chưa
     * @author: BMThang(29/03/2023)
     */
    setIsGettedData: (state, isGettedData) => {
      state.isGettedData = isGettedData;
    },

    setTourLiveChat: (state, tourLiveChat) => {
      state.tourLiveChat = tourLiveChat;
    },

    setIsActive: (state, isActive) => {
      state.isActive = isActive;
    },

    /**
     * xét tình trạng người dùng đã xem Điểm nổi bật của V2 hay chưa
     * NTDIEM 29/06/2023
     * @param {*} state
     * @param {*} tourGuideUpdate
     */
    setTourGuideUpdate: (state, tourGuideUpdate) => {
      state.tourGuideUpdate = tourGuideUpdate;
    },
    /**
     * Xét bước hiện tại của TourGuide Điểm nổi bật của V2
     * @param {*} state
     * @param {*} tourGuideUpdateStep
     */
    setTourGuideUpdateStep: (state, tourGuideUpdateStep) => {
      state.tourGuideUpdateStep = tourGuideUpdateStep;
    },
    setIsShowTourGuideDashBoard: (state, isShowTourGuideDashBoard) => {
      state.isShowTourGuideDashBoard = isShowTourGuideDashBoard;
    },
  },
  actions: {
    /**
     * Lấy tour guide config
     * @param {*}
     * @author: BMThang(03/04/2023)
     */
    getTourGuideConfig: async ({ commit, rootState }) => {
      // Nếu ko phải admin thì cook
      
      if (!rootState.context.User.IsAdmin) return;
      try {
        const res = await optionAPI.getDbOptions(OptionKey);
        if (res.OptionValue) commit('setTourGuideConfig', res.OptionValue);
        else commit('setTourGuideConfig', {});
      } catch (err) {
        console.log(err);
        commit('setTourGuideConfig', {});
      } finally {
        commit('setIsGettedData', true);
      }
    },

    /**
     * Lưu bước của tour guide
     * @param {*}
     * @param {object}
     * @author: BMThang(03/04/2023)
     */
    saveTourGuideStep: async ({ commit, state }, { tourGuideKey, step }) => {
      const newTourGuideConfig = {
        ...state.tourGuideConfig,
        [tourGuideKey]: step,
      };
      try {
        await optionAPI.updateDbOptions({
          model: {
            optionKey: OptionKey,
            optionValueType: OptionValueType.Object,
            optionValue: newTourGuideConfig,
          },
        });
        commit('setTourGuideConfig', newTourGuideConfig);
      } catch (err) {
        console.log(err);
        commit('setTourGuideConfig', state.tourGuideConfig);
      }
    },

    /**
     * gọi APi lấy dữ liệu người dùng đã xem Điểm nỏi bật V2 hay chưa
     * NTDIEM 29/06/2023
     * false: chưa xem
     * true: đã xem
     * null: không phải người dùng từ V1 lên V2 nên ko hiện
     * @param {*} param0
     */
    checkTourGuideUpdate: async ({ commit }) => {
      await optionAPI.getDbOptions('tourGuideUpdate').then((res) => {
        if (
          res.OptionValue == true ||
          res.OptionValue == null ||
          res.OptionValue == undefined
        )
          commit('setTourGuideUpdate', true);
        else commit('setTourGuideUpdate', false);
      });
    },
    setTourGuideUpdate: async ({ commit }, value) => {
      commit('setTourGuideUpdate', value);
    },
    setTourGuideUpdateStep: async ({ commit }, value) => {
      commit('setTourGuideUpdateStep', value);
    },
    setIsShowTourGuideDashBoard: async ({ commit }, value) => {
      commit('setIsShowTourGuideDashBoard', value);
    },
  },
};
